import { Component, OnInit, OnChanges, Input, Output, EventEmitter } from '@angular/core';
import { LiftHistogramComponent } from '../map/lift-histogram/lift-histogram.component';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { ColorUtilityService } from '../../../analytics-core/services/color.utility.service';
import { MAP_CONSTANTS, PATHS } from '../../../analytics/constants/analytics.constants';
import * as _ from 'underscore';

@Component({
	selector: 'app-r7-lift-histogram',
	templateUrl: './r7-lift-histogram.component.html',
	styleUrls: ['./r7-lift-histogram.component.css']
})
export class R7LiftHistogramComponent extends LiftHistogramComponent implements OnInit, OnChanges {
	@Input() histogramData;
	@Input() chartOptions;
	@Input() liftColor;
	@Output() showLiftRegions = new EventEmitter<any>();
	@Output() hideLiftRegions = new EventEmitter<any>();
	@Output() toggleLiftRegions = new EventEmitter<any>();
	@Input() path: any;

	public liftObj: any = {};
	public hideDistributionGraph = true;
	protected selectedBarIndex = -1;

	constructor(protected analyticsDataModel: AnalyticsDataModel, protected colorUtilityService: ColorUtilityService) {
		super(analyticsDataModel, colorUtilityService);
	}

	ngOnInit() {}

	ngOnChanges() {
		super.ngOnChanges();
	}

	getGraphWidth() {
		if (this.path === PATHS.OVERVIEW) {
			return 275;
		} else if (this.path === PATHS.DISPLAY) {
			return 255;
		} else if (this.path === PATHS.PREROLL) {
			return 240;
		}
	}
}
